import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {FreeSpinsModule} from '@gongxigames/framework/slot/modules/freespins/FreeSpinsModule';
import {GenericPopupEvents} from '@gongxigames/framework/slot/modules/genericPopup/GenericPopupEvents';
import {GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup/GenericPopupType';

export class FreeSpinsIntroState extends ModuleState<null, FreeSpinsModule> {

    public onEnterState(): void {
        const type = GenericPopupType.FREESPIN_INTRO;

        this.emit(GenericPopupEvents.SHOW_POPUP, type, this.module.getValueByType(type));
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        this.setEventHandler(GenericPopupEvents.FADE_OUT_STARTED, this.onPopupFadeOut.bind(this));
    }

    protected onPopupFadeOut(): void {
        this.module.gotoState(FreeSpinsModule.IN_PROGRESS_STATE);
    }
}
